import APIError from './APIError';

export default class AccessError extends APIError {
  static HTTP_CODES = [403, 404, 412];

  static ERROR_CODES = {
    FORBIDDEN: 'forbidden',
    FAILED_PRECONDITION: 'failedPrecondition',
    STEP_LOCKED: 'stepLocked',
    ENROLLMENT_NOT_FOUND: 'enrollmentNotFound',
    ENROLLMENT_ALREADY_FINISHED: 'enrollmentAlreadyFinished',
    NO_THERAPISTS_AVAILABLE: 'noTherapistsAvailable',
    WITH_SLOTS_NO_THERAPISTS_AVAILABLE: 'withSlotsNoTherapistAvailable',
    NO_SCHEDULE_AVAILABLE: 'noScheduleAvailable',
    EARLY_KIT_ALREADY_SENT: 'earlyKitAlreadySent',
  };

  constructor(error) {
    super({ name: 'AccessError', message: 'Could not access API resource' });

    this.response = undefined;
    this.status = undefined;
    this.code = undefined;
    this.reason = undefined;
    this.data = undefined;
    this.parsePayload(error);
  }

  parsePayload(error) {
    const errorResponse = error?.response;
    const errorData = errorResponse?.data;

    this.response = errorResponse;
    this.status = errorResponse?.status;
    this.code = AccessError.ERROR_CODES[errorData?.code] || errorData?.code;
    this.reason = errorData?.reason;
    this.data = errorData?.data;
  }

  static matchesFormat(error) {
    const errorStatus = error?.response?.status;
    const errorCode = error?.response?.data?.code;
    if (!errorStatus) return false;

    const hasAccessStatus = AccessError.HTTP_CODES.includes(errorStatus);
    const hasAccessCode = errorCode in AccessError.ERROR_CODES;
    return hasAccessStatus && hasAccessCode;
  }
}
